import Button from "../../UI/Button";
import ModalDialog from "../../UI/ModalDialog";
import Text from "../../UI/Text";
import usePriorityActions from "../../../hooks/use-priority-actions";
import type { PriorityAction } from "../../../models/priorityAction";
import { TYPE_CONFIG } from "./priorityActionConfig";
import styles from "./ArchivedActionsDialog.module.css";

interface ArchivedActionsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRestored: () => void;
}

export default function ArchivedActionsDialog({
  open,
  onOpenChange,
  onRestored,
}: ArchivedActionsDialogProps) {
  const { actions, restoreAction, mutate, isLoading } = usePriorityActions({
    archived: true,
  });

  async function restore(action: PriorityAction) {
    await restoreAction(action.id);
    await mutate();
    onRestored();
  }

  return (
    <ModalDialog
      size="sm"
      open={open}
      header="Actions archivées"
      onOpenChange={onOpenChange}
    >
      <div className={styles.list}>
        {actions.map((action) => {
          const Icon = TYPE_CONFIG[action.type]?.icon;
          return (
            <div key={action.id} className={styles.item}>
              <Text as="div" color="muted" background className={styles.icon}>
                {Icon && <Icon size={20} />}
              </Text>
              <div className={styles.text}>
                <Text as="span" weight="medium">
                  {action.title}
                </Text>
                {action.description && (
                  <Text as="span" color="muted">
                    {action.description}
                  </Text>
                )}
              </div>
              <Button
                variant="secondary"
                size="sm"
                onClick={() => restore(action)}
              >
                Restaurer
              </Button>
            </div>
          );
        })}
        {!isLoading && actions.length === 0 && (
          <Text color="muted">Aucune action archivée</Text>
        )}
      </div>
    </ModalDialog>
  );
}
